export default "__VITE_ASSET__BTw2sEGD__"